// Lightweight activity tracker. Fire-and-forget; never blocks the UI.
import { supabase } from './supabase'

let _config = null
let _loginLogged = false
export function setTrackConfig(config) { _config = config }

// a page view is sent once the user stays on the page (PAGE_DWELL): a quick walk through pages sends only where they stopped, so
// no insert is cut off by the next page change (audit-full F-8: a "CORS" console error on Hours of rest for a crew login was an
// activity_events insert that never got its reply). Offline: nothing is sent (it is only tracking).
export const PAGE_DWELL = 1500
let _pageTimer = null
export function track(action, module = null, detail = null) {
  if (action === 'page_view') {
    if (_pageTimer) clearTimeout(_pageTimer)
    _pageTimer = setTimeout(() => { _pageTimer = null; send(action, module, detail) }, PAGE_DWELL)
    return Promise.resolve()
  }
  return send(action, module, detail)
}
async function send(action, module, detail) {
  try {
    if (!_config) return
    if (typeof navigator !== 'undefined' && navigator.onLine === false) return
    await supabase.from('activity_events').insert({
      client_id: _config.id,
      actor_type: _config.accountType === 'crew' ? 'crew' : 'vessel',
      actor_id: _config.crewAccountId || _config.id,
      actor_name: _config.crewName || _config.vessel_name || null,
      action,
      module,
      detail,
    })
  } catch (e) { /* silent */ }
}

export async function trackLogin(config) {
  if (!config) return
  setTrackConfig(config)
  // Synchronous guard FIRST — blocks the race before any await.
  if (_loginLogged) return
  const key = 'hc_login_logged_' + (config.crewAccountId || config.id)
  try { if (sessionStorage.getItem(key)) { _loginLogged = true; return } } catch {}
  _loginLogged = true
  try { sessionStorage.setItem(key, '1') } catch {}
  try {
    const table = config.accountType === 'crew' ? 'crew_accounts' : 'clients'
    const id = config.accountType === 'crew' ? config.crewAccountId : config.id
    if (id) await supabase.from(table).update({ last_login: new Date().toISOString() }).eq('id', id)
    await track('login')
  } catch (e) { /* silent */ }
}
